export default "__VITE_ASSET__DxfkzIp0__"